<template>
  <div class="vehicle-animation">
    <div class="exhaust-container">
      <div class="exhaust-puff puff-1"></div>
      <div class="exhaust-puff puff-2"></div>
      <div class="exhaust-puff puff-3"></div>
    </div>
    <div class="vehicle-icon">
      <svg viewBox="0 0 80 36" width="60" height="27">
        <rect x="4" y="6" width="70" height="22" rx="4" fill="#2c5aa0"/>
        <rect x="4" y="18" width="70" height="4" fill="#1a3d6e"/>
        <rect x="8" y="8" width="8" height="9" rx="1" fill="#87ceeb"/>
        <rect x="18" y="8" width="8" height="9" rx="1" fill="#87ceeb"/>
        <rect x="28" y="8" width="8" height="9" rx="1" fill="#87ceeb"/>
        <rect x="38" y="8" width="8" height="9" rx="1" fill="#87ceeb"/>
        <rect x="48" y="8" width="8" height="9" rx="1" fill="#87ceeb"/>
        <rect x="58" y="8" width="12" height="9" rx="2" fill="#87ceeb"/>
        <circle cx="18" cy="28" r="5" fill="#333"/>
        <circle cx="18" cy="28" r="2" fill="#666"/>
        <circle cx="58" cy="28" r="5" fill="#333"/>
        <circle cx="58" cy="28" r="2" fill="#666"/>
        <rect x="71" y="14" width="2" height="4" rx="1" fill="#ffdd00"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoachBusAnimation'
}
</script>

<style scoped>
.vehicle-animation {
  display: flex;
  align-items: center;
}

.exhaust-container {
  position: relative;
  width: 0px;
  height: 24px;
  margin-left: 20px;
}

.exhaust-puff {
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: #999;
  border-radius: 50%;
  opacity: 0;
  right: 0;
}

.puff-1 {
  bottom: 4px;
  animation: puff-float 1.2s ease-out infinite;
}

.puff-2 {
  bottom: 8px;
  animation: puff-float 1.2s ease-out infinite 0.4s;
}

.puff-3 {
  bottom: 12px;
  animation: puff-float 1.2s ease-out infinite 0.8s;
}

.vehicle-icon {
  animation: vehicle-bounce 0.5s ease-in-out infinite;
}

@keyframes vehicle-bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-2px); }
}

@keyframes puff-float {
  0% {
    opacity: 0.7;
    transform: translateX(0) scale(0.5);
  }
  100% {
    opacity: 0;
    transform: translateX(-15px) scale(1.2);
  }
}
</style>
